import { useSyncStore } from '../../store/syncStore';
import { useGameStore } from '../../store/gameStore';
import { getFunctionBaseUrl } from './urlHelper';

type SyncedStats = {
  stars: number;
  gameStats: Record<string, { wordsHighScore: number; pointsHighScore: number }>;
  unlockedColors: string[];
};

export async function generateSyncProfile(stats: SyncedStats): Promise<string> {
  const baseUrl = getFunctionBaseUrl();
  const res = await fetch(`${baseUrl}/.netlify/functions/createSyncCode`);
  if (!res.ok) throw new Error('Failed to create sync profile');

  const { sync_code, write_key } = await res.json();

  await fetch(`${baseUrl}/.netlify/functions/uploadStats`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sync_code,
      write_key,
      stats,
    }),
  });

  useSyncStore.getState().setSyncCode(sync_code);
  useSyncStore.getState().setWriteKey(write_key);

  return sync_code;
}

export async function syncStats(stats: SyncedStats) {
  const { syncCode, writeKey } = useSyncStore.getState();
  if (!syncCode || !writeKey) return;

  const baseUrl = getFunctionBaseUrl();
  await fetch(`${baseUrl}/.netlify/functions/uploadStats`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sync_code: syncCode, write_key: writeKey, stats }),
  });
}

export async function restoreStats(syncCode: string) {
  const baseUrl = getFunctionBaseUrl();
  const res = await fetch(`${baseUrl}/.netlify/functions/downloadStats?code=${syncCode}`);
  if (!res.ok) throw new Error('Sync code not found');

  const { stats, write_key } = await res.json();

  useGameStore.setState({
    stars: stats.stars,
    gameStats: stats.gameStats,
    unlockedColors: stats.unlockedColors,
  });

  useSyncStore.getState().setSyncCode(syncCode);
  useSyncStore.getState().setWriteKey(write_key);
}
